import { useState } from 'react';
import { Loader2, Printer } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ReprintDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  documentNames: string[];
  onConfirm: (copies: number) => void;
  isPending: boolean;
}

export function ReprintDialog({
  open,
  onOpenChange,
  documentNames,
  onConfirm,
  isPending,
}: ReprintDialogProps) {
  const [copies, setCopies] = useState(2);

  const handleConfirm = () => {
    onConfirm(copies);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Printer className="h-5 w-5" />
            Перепечатать документы
          </DialogTitle>
          <DialogDescription>
            Будет создана заявка на перепечатку
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Document list */}
          <div className="max-h-40 overflow-y-auto border rounded-md p-2 bg-muted/30">
            <ul className="space-y-1 text-sm">
              {documentNames.map((name, i) => (
                <li key={i} className="flex items-start gap-2">
                  <span className="text-muted-foreground">•</span>
                  <span>{name}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Copies input */}
          <div className="space-y-2">
            <Label htmlFor="copies">Количество копий</Label>
            <Input
              id="copies"
              type="number"
              min={1}
              max={10}
              value={copies}
              onChange={(e) => setCopies(parseInt(e.target.value) || 1)}
              className="w-24"
            />
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            Отмена
          </Button>
          <Button onClick={handleConfirm} disabled={isPending}>
            {isPending ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <Printer className="h-4 w-4 mr-2" />
            )}
            Создать заявку
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
